// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"100":"forgot-password","710":"buyer-registration","966":"login"}[chunkId] || chunkId) + "." + {"100":"8099e1ea","268":"3ff16510","710":"f44a5f7d","822":"ea6e744b","966":"31333bdd"}[chunkId] + ".js";
};